import styled from "styled-components";

export const Span = styled.span`
    margin-bottom: 30px;
    font-size: 20px;
    text-align:'center';
`;

export const Subtitle = styled.span`
  font-size: 16px;
  text-align:'center';
`;

export const ButtonClose = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  transition: .4s;

  &&:hover {
    transform: scale(.95);
  }
`;

export const Text = styled.span`
  padding: 10px 0 10px 10px;
  text-align: center;
`
